/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_JulInputs */

const en_better_studio_month_jul = /** @type {(inputs: Better_Studio_Month_JulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jul`)
};

/**
* | output |
* | --- |
* | "Jul" |
*
* @param {Better_Studio_Month_JulInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_jul = /** @type {((inputs?: Better_Studio_Month_JulInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_JulInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_jul(inputs)
});